module.exports = __webpack_public_path__ + "static/media/search-icon.8aba2476.svg";